// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

// Style Imports
import { bs, colors, space } from '../../style/design-system'

const Card = ({ children, className, backgroundImage }) => (
  <div className={`${className ? `${className} ` : ''}card`}>
    {backgroundImage && <img src={backgroundImage} alt="" />}
    {children}
  </div>
)

export default styled(Card)`
  background-color: ${(props) => props.cardBackground};
  border-radius: ${space.a};
  box-shadow: ${(props) => props.cardShadow};
  padding: ${space.d};
`

Card.propTypes = {
  backgroundImage: PropTypes.string,
  cardBackground: PropTypes.string,
  cardShadow: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

Card.defaultProps = {
  backgroundImage: '',
  cardBackground: colors.umaUltimateLightGray,
  cardShadow: bs.standard,
  className: '',
}
